module.exports = __webpack_public_path__ + "img/Understand_preprocessing.d64e5a10.png";